// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-body {
  padding: 0;
  background-color: #f7f8fc;
}

.task {
  width: 100%;
  border-radius: 2px;
  box-shadow: 0 2px 6px 3px #f4f4f4;
  background-color: #ffffff;
  margin: 10px;
}

.task-name {
  padding-top: 10px;
}

.colored-blocks {
  width: auto;
  height: 20px;
  border-radius: 9px;
  background-color: #e6e9f0;
  margin: 10px 4px 10px 4px;
  text-align: center;
}
.colored-blocks span {
  color: #8291ae;
  padding: 0px 5px 0 5px;
}
.colored-blocks .clock {
  width: 16px;
  height: 16px;
  object-fit: contain;
  color: #8291ae;
  float: left;
}

.blocks,
.controls {
  display: inline-flex;
  align-self: center;
}

.green {
  background-color: #daf8e6;
  color: #0fa34d;
}

.repets {
  margin: 10px 4px 10px 4px;
}
.repets i-feather {
  width: 10px !important;
  color: #8291ae;
}

.controls {
  float: right;
  margin: 10px 8px 10px 8px;
}
.controls i-feather {
  height: 24px !important;
  width: 24px !important;
  color: #1161be;
}

.task-more {
  position: relative;
  height: 16px;
}
.task-more i-feather::ng-deep {
  height: 16px;
}
.task-more i-feather::ng-deep svg {
  height: 16px;
  top: -4px;
}
.task-more ul li a {
  font-size: 14px;
}

.info {
  text-align: right;
  padding-right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/boards/recurring-task-list/recurring-task-list.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EAEA,yBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;AAAF;;AAEA;EACE,iBAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAEF;AADE;EACE,cAAA;EACA,sBAAA;AAGJ;AAAE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAEJ;;AAEA;;EAEE,oBAAA;EACA,kBAAA;AACF;;AACA;EACE,yBAAA;EACA,cAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;AAFE;EACG,sBAAA;EACD,cAAA;AAIJ;;AADA;EACE,YAAA;EACA,yBAAA;AAIF;AAHE;EACE,uBAAA;EACA,sBAAA;EACA,cAAA;AAKJ;;AADA;EACE,kBAAA;EACA,YAAA;AAIF;AAFE;EACE,YAAA;AAIJ;AAFI;EACE,YAAA;EACA,SAAA;AAIN;AAAE;EACE,eAAA;AAEJ;;AACA;EACE,iBAAA;EACA,kBAAA;AAEF","sourcesContent":[".card-body {\n  padding: 0;\n // background-color: white !important;\n  background-color: #f7f8fc;\n\n}\n.task {\n  width: 100%;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px 3px #f4f4f4;\n  background-color: #ffffff;\n  margin: 10px;\n}\n.task-name {\n  padding-top: 10px;\n}\n.colored-blocks {\n  width: auto;\n  height: 20px;\n  border-radius: 9px;\n  background-color: #e6e9f0;\n  margin: 10px 4px 10px 4px;\n  text-align: center;\n  span {\n    color: #8291ae;\n    padding: 0px 5px 0 5px;\n  }\n\n  .clock {\n    width: 16px;\n    height: 16px;\n    object-fit: contain;\n    color: #8291ae;\n    float: left;\n  }\n}\n\n.blocks,\n.controls {\n  display: inline-flex;\n  align-self: center;\n}\n.green {\n  background-color: #daf8e6;\n  color: #0fa34d;\n}\n.repets {\n  margin: 10px 4px 10px 4px;\n  i-feather {\n     width: 10px !important;\n    color: #8291ae;\n  }\n}\n.controls {\n  float: right;\n  margin: 10px 8px 10px 8px;\n  i-feather {\n    height: 24px !important;\n    width: 24px !important;\n    color: #1161be;\n  }\n}\n\n.task-more {\n  position: relative;\n  height: 16px;\n\n  i-feather::ng-deep {\n    height: 16px;\n\n    svg {\n      height: 16px;\n      top: -4px;\n    }\n  }\n\n  ul li a {\n    font-size: 14px;\n  }\n}\n.info {\n  text-align: right;\n  padding-right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
